import PropTypes, { any } from 'prop-types';
import React from 'react';
import styles from '../search.scss';
import Filter, { FilterModal, FilterSection } from './Filter';
import DropdownFilter from './FilterComponents/CoreComponents/DropdownFilter';

const SnapshotDateFilter = (props) => {
    const { type = '', filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, handleFilterUpdate, mobileOnly, desktopOnly, snapshotDates, 'data-testid': dataTestId } = props;

    const selectedSnapshotDateValue = filters.snapshotDate && snapshotDates.find(v => v.value === filters.snapshotDate);
    const collegeCornerFilterValue = selectedSnapshotDateValue?.description ? selectedSnapshotDateValue.description : 'All snapshotDates';
    const filterName = 'snapshotDate';

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={filterName}
                searchFor={type}
                handleFilterClick={handleFilterClick}
                isActive={(filters.snapshotDate) || filterModal === filterName}
                onClick={() => handleFilterClick(filterName)}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                {type === 'collegeCorner' ? collegeCornerFilterValue : 'SnapshotDate'}
            </Filter>
            {filterModal === filterName && (
                <FilterModal
                    title={'SnapshotDate'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <DropdownFilter
                            options={snapshotDates}
                            selected={filterInputs.snapshotDate}
                            placeholder=""
                            onChange={(snapshotDate) => {
                                handleFilterUpdate({ snapshotDate });
                            }}
                            data-testid={dataTestId && `${dataTestId}.dropdown`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

SnapshotDateFilter.propTypes = {
    type: PropTypes.string,
    filters: PropTypes.objectOf(any).isRequired,
    filterInputs: PropTypes.objectOf(any).isRequired,
    filterModal: PropTypes.string.isRequired,
    handleFilterClick: PropTypes.func,
    closeModals: PropTypes.func,
    handleFilterSubmit: PropTypes.func,
    handleFilterUpdate: PropTypes.func,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    snapshotDates: PropTypes.arrayOf(any),
    'data-testid': PropTypes.string,
};

SnapshotDateFilter.defaultProps = {
    type: '',
    handleFilterClick: () => { },
    closeModals: () => { },
    handleFilterSubmit: () => { },
    handleFilterUpdate: () => { },
    mobileOnly: false,
    desktopOnly: false,
    snapshotDates: [],
    'data-testid': undefined,
};

export default SnapshotDateFilter;
